<script>
    import LayoutGrid, {Cell as LayoutCell} from "@smui/layout-grid";
    import DataTable, {Body, Cell, Row} from "@smui/data-table";

    import Currency from "./Currency.svelte";

    export let result = undefined;
    export let span = 4;
    export let cssClass = "no-web";
</script>
<LayoutCell span={span} class="{cssClass}">
    <DataTable style="width: 100%;">
        <Body>
        <Row style="height: 25px;">
            <Cell>Salaire Brut</Cell>
            <Cell style="text-align: right">
                <Currency number={result.totalBaseGross}/>
            </Cell>
        </Row>
        <Row style="height: 25px;">
            <Cell>Charges Salariales</Cell>
            <Cell style="text-align: right">
                <Currency number={result.totalSalaryContributions}/>
            </Cell>
        </Row>
        <Row style="height: 25px;">
            <Cell>Charges Patronales</Cell>
            <Cell style="text-align: right">
                <Currency number={result.totalEmployerContributions}/>
            </Cell>
        </Row>
        <Row style="height: 25px;">
            <Cell>Remboursement Frais</Cell>
            <Cell style="text-align: right">
                <Currency number={result.travellingExpenses}/>
            </Cell>
        </Row>
        </Body>
    </DataTable>
</LayoutCell>